var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locked-content-header"},[_c('LockIcon',{attrs:{"size":"14"}}),_vm._v(" Locked content")],1)}
var staticRenderFns = []

export { render, staticRenderFns }